import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { PerformanceProvider } from './performance.context';
import { PerformanceViewProps } from './performance.interfaces';
import { PerformanceContent } from './performanceComponents';
import { useTranslation } from 'src/hooks/useTranslationHook';

// Main component that provides the context
const PerformanceView: FC<PerformanceViewProps> = () => {
  const { translateText } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{translateText('analytics.performance.titleHelmet')}</title>
      </Helmet>
      <PerformanceProvider>
        <PerformanceContent />
      </PerformanceProvider>
    </>
  );
};

export default PerformanceView;
